import { render, staticRenderFns } from "./configuration-automation-grossing-shelf-sample-type-and-shelf-modal-basic-form.vue?vue&type=template&id=6514e559&scoped=true&"
import script from "./configuration-automation-grossing-shelf-sample-type-and-shelf-modal-basic-form.ts?vue&type=script&lang=ts&"
export * from "./configuration-automation-grossing-shelf-sample-type-and-shelf-modal-basic-form.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-automation-grossing-shelf-sample-type-and-shelf-modal-basic-form.scss?vue&type=style&index=0&id=6514e559&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6514e559",
  null
  
)

export default component.exports